import { action, ObservableMap, makeObservable } from "mobx";
export class TogglePrePacksStatusRetriever {
    constructor() {
        this.statuses = new ObservableMap();
        makeObservable(this, {
            set: action,
            delete: action
        });
    }
    activate() { }
    deactivate() {
        this.statuses.clear();
    }
    get(eventId, prePackId) {
        var _a;
        return (_a = this.statuses.get(eventId)) === null || _a === void 0 ? void 0 : _a.get(prePackId);
    }
    set({ status, eventId, prePackId, }) {
        const map = this.statuses.get(eventId) || new Map();
        // "Selected" status should override existing statuses for Event.
        if (status.type === "Selected") {
            map.clear();
        }
        map.set(prePackId, status);
        this.statuses.set(eventId, map);
    }
    delete(eventId) {
        this.statuses.delete(eventId);
    }
}
//# sourceMappingURL=TogglePrePacksStatusRetriever.js.map